import React from "react";

import styles from "./textField.module.css";
type TextFieldProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "onChange"
> & {
  label: string;
  disabled?: boolean;
  value: string;
  placeholder?: string;
  customStyles?: React.CSSProperties;
  inputAlign?: "left" | "right";
  type?: string;
  suffix?: React.ReactNode;
  mutedPlaceholder?: boolean;
  onChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  inputStyles?: React.CSSProperties;
  asTextArea?: boolean;
};
export const TextField = ({
  label,
  disabled,
  value,
  placeholder,
  customStyles,
  inputAlign = "left",
  type = "text",
  suffix,
  mutedPlaceholder,
  onChange,
  inputStyles,
  asTextArea = false,
  ...props
}: TextFieldProps) => {
  const textAreaRef = React.useRef<HTMLTextAreaElement>(null);

  React.useEffect(() => {
    if (asTextArea && textAreaRef.current) {
      textAreaRef.current.style.height = "auto";
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
    }
  }, [value, asTextArea]);

  return (
    <div className={styles.textField} style={customStyles}>
      <label>{label}</label>
      {asTextArea ? (
        <textarea
          ref={textAreaRef}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          style={{
            ...inputStyles,
            resize: "none",
            overflow: "hidden",
            padding: "10px",
            color: "#364153",
            borderRadius: "10px",
            border: "1.25px solid #D1D5DC",
          }}
          {...(props as React.TextareaHTMLAttributes<HTMLTextAreaElement>)}
        />
      ) : (
        <input
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          style={inputStyles}
          {...props}
        />
      )}
      {suffix && <span className={styles["text-field-suffix"]}>{suffix}</span>}
    </div>
  );
};
